// removed by extract-text-webpack-plugin
module.exports = {"overlay":"zkF0","sidebar":"_3X-D","fadeEnter":"_3ujM","fadeEnterActive":"_1kio","fadeExit":"_1C_K","fadeExitActive":"sCti","inner":"_3uuB","link":"iXWQ","active":"RGiI","otherLink":"_17iD","divider":"_1bD6","footer":"lMsa","copyright":"_22tn","user":"_3h_V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.scss
// module id = hp3g
// module chunks = 0